// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/chunks/" + ({"5996":"8d06a44d","6831":"0b02c20c","8503":"f68e9ce8"}[chunkId] || chunkId) + "." + {"5996":"240885752c40f0a9","6831":"47c1eaa81b9b0d89","8503":"f34631e89f870437","9683":"ff262adc6f9d10a4"}[chunkId] + ".js";
};